import {
  NotificationPreference,
  PreferenceOption,
} from '../../types/preference.types';
import instance from './axios';

const ENDPOINTS = {
  PREFERENCE: '/account/my-preference',
};

const getPreference = () => {
  return instance.get<{
    cats: NotificationPreference;
  }>(ENDPOINTS.PREFERENCE);
};

const updatePreference = (data: { [key: string]: PreferenceOption[] }) => {
  return instance.post<any>(ENDPOINTS.PREFERENCE, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

const PreferenceApi = {
  getPreference,
  updatePreference,
};

export default PreferenceApi;
